import { useDispatch } from "react-redux";
import { CartIcon } from "../../../assets"
import styles from "./style.module.css"
import { toggleCartVisibility } from "../../../redux/slices/cartVisibilitySlice";

export const CartButton = () =>{

    const dispatch = useDispatch()

    return(

            <CartIcon 
            className={styles.icon}
            onClick={() => {

                dispatch(toggleCartVisibility()); 
                
            }}
            />
    
    )

}